import React from 'react';
import { Select, DatePicker, Tooltip } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { 
  CheckCircle2, 
  Circle, 
  AlertTriangle, 
  Database, 
  FileEdit, 
  ClipboardCheck, 
  Rocket,
  Paperclip
} from 'lucide-react';
import { TASK_TYPE } from '../constants';
import { SelfCheckSvg, TipSvg, JumpSvg } from "@/components/svgs/project"

interface TaskItemProps {
  task: API.PROJECTHQ.TypeTask;
  onToggleManual: (taskId: string) => void;
  onActionClick: (task: API.PROJECTHQ.TypeTask) => void;
  handleAttachmentManagerOpen: (task: API.PROJECTHQ.TypeTask) => void;
  onStatusChange: (task: API.PROJECTHQ.TypeTask, status: number) => void;
  onCompletedAtChange: (task: API.PROJECTHQ.TypeTask, completedAt: string | null) => void;
}

export const TaskItem: React.FC<TaskItemProps> = ({ task, onToggleManual, onActionClick, handleAttachmentManagerOpen, onStatusChange, onCompletedAtChange }) => {
  const isCompleted = task.status === 1;
  const isWarning = task.status === 0;

  const getStatusColor = () => {
    if (isCompleted) return 'text-success';
    if (isWarning) return 'text-warning';
    return 'text-accent'; // Red for incomplete/pending
  };

  const handleSelectChange = (value: number) => {
    onStatusChange(task, value);
  };

  const handleDateChange = (date: Dayjs | null) => {
    const completedAt = date ? date.format('YYYY-MM-DD') : null;
    onCompletedAtChange(task, completedAt);
  };

  const renderIcon = () => {
    switch (task.type) {
      case TASK_TYPE.tip:
        return (
          <Tooltip title="提示关注">
            <div className='text-yellow-700 bg-yellow-100 rounded-full p-1 flex'>
              <TipSvg />
            </div>
          </Tooltip>
        );
      case TASK_TYPE.jump:
        return (
          <div className='text-orange-500 bg-orange-100 rounded-full p-1 flex'>
            <JumpSvg />
          </div>
        );
      case TASK_TYPE.selfcheck:
        return (
          <div className='text-purple-500 bg-purple-100 rounded-full p-1 flex'>
            <SelfCheckSvg />
          </div>
        );
      case TASK_TYPE.dds:
        return (
          <div className='text-gray-800 bg-gray-100 text-xs rounded-md p-1 flex'>
            DDS
          </div>
        );
      default:
        return <></>
    }
  };

  const taskItem = (
    <div className={`
      group flex flex-row items-center justify-between p-4 mb-3 bg-white rounded-lg border 
      hover:shadow-md transition-shadow duration-200
    `}>
      <div className="flex items-center justify-between w-full gap-2">
        <div>{renderIcon()}</div>
        <div className={`flex-1 ${task.type === TASK_TYPE.tip ? 'text-gray-500' : ''}`}>{task.value}</div>
        {/* Status Selector - Antd */}
        <div className="w-[100px] flex items-center justify-center">
          {task.type !== TASK_TYPE.tip && (
            <Select
              value={task.status}
              onChange={handleSelectChange}
              className="w-full"
            >
              <Select.Option value={0}>未完成</Select.Option>
              <Select.Option value={1}><span className='text-green-500'>已完成</span></Select.Option>
            </Select>
          )}
          
        </div>

        {/* Date Picker */}
        {/* <div className="w-[100px] flex items-center justify-center">
          <DatePicker
            showNow={false}
            value={task.completedAt ? dayjs(task.completedAt) : null}
            onChange={handleDateChange}
            placeholder="选择日期"
            className="w-full"
          />
        </div> */}

        {/* Action Button Area */}
        <div className="w-[120px] flex items-center justify-center flex-wrap gap-2">
          {task.type === TASK_TYPE.dds && !task.isNotDdsSpecial && (
            <span className='text-gray-400 text-xs'>
              请到PM打开DDS空间
            </span>
            // <button
            //   onClick={() => handleAttachmentManagerOpen(task)}
            //   className="px-2 py-1.5 rounded flex items-center text-xs bg-primary text-white hover:bg-primary/80"
            // >
            //   <Paperclip size={12} className="mr-1" />
            //   附件管理
            // </button>
          )}
          {task.type === TASK_TYPE.dds && task.isNotDdsSpecial && task.url && (
            <a
              href={task.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`px-2 py-1.5 rounded flex items-center text-xs bg-blue-500 text-white hover:bg-blue-500/80 hover:underline`}
            >
              <Paperclip size={12} className="mr-1" /> 文档管理
            </a>
          )}


          {task.type === TASK_TYPE.jump && (
            <a 
              href={task.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`px-2 py-1.5 rounded flex items-center text-xs bg-blue-500 text-white hover:bg-blue-500/80 hover:underline`}
            >
              <JumpSvg />
                跳转
            </a>
          )}
        </div>
      </div>
    </div>
  );

  return taskItem;
};